import React, { FC } from 'react';
import LogoSrc from './Logo.svg';

const Logo: FC = () => {
    return <img src={LogoSrc} alt="Voop Logo" width="32" height="32" />
}

export default Logo;
